import { useEffect } from 'react';

function ZendeskScript() {
    useEffect(() => {
        const zendeskKey = import.meta.env.VITE_ZENDESK_WIDGET_KEY;
        if (!zendeskKey) {
            return;
        }

        const scriptId = 'ze-snippet';
        let script = document.querySelector<HTMLScriptElement>(`#${scriptId}`);

        if (!script) {
            script = document.createElement('script');
            script.async = true;
            script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
            script.id = scriptId;

            document.head.appendChild(script);
        }

        // No cleanup - Zendesk widget should persist throughout the entire app lifecycle
    }, []);

    return null;
}

export { ZendeskScript };
